import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import NAVBARCOPY from '../NavBarCopy';
import getMyTeamMenuItems from '../../../../helpers/TeamMenuHelpers';

const getNavBarLinks = (userData, session) => {
  if (!userData || !userData.user) {
    return [];
  }
  const { user } = userData;
  const teamMembership = user.teamMembership || {};
  const canSeeTeamTab = teamMembership.isAdmin || teamMembership.isEnterprise;
  const navBarLinks = [
    {
      path: createURL('/dashboard/', { ut_source: 'header' }),
      name: t(NAVBARCOPY.DASHBOARD)
    },
    {
      path: createURL('/home/', { ut_source: 'header' }),
      name: t(NAVBARCOPY.MY_SURVEYS)
    },
    canSeeTeamTab && {
      name: t(NAVBARCOPY.MY_TEAM),
      menu_items: getMyTeamMenuItems({ user, session }),
      key: 'team'
    },
    {
      path: createURL('/pricing/upgrade/quickview/', {
        ut_source: 'header_loggedIn'
      }),
      name: t(NAVBARCOPY.PLANS_AND_PRICING)
    }
  ];
  return navBarLinks.filter(Boolean);
};
export default getNavBarLinks;
